import type {CSSProperties, FC} from 'react';

type PictureProps = {
  srcSet: string | string[];
  className?: string;
  id?: string;
  style?: CSSProperties;
  alt?: string;
  loading?: 'eager' | 'lazy';
  'data-qa-id'?: string;
  width?: number;
  height?: number;
  onError?: () => void;
  onLoad?: () => void;
};

export const Picture: FC<PictureProps> = ({
  srcSet,
  className,
  id,
  style,
  alt,
  loading = 'eager',
  'data-qa-id': dataQaId,
  width,
  height,
  onError,
  onLoad,
}) => {
  const srcSetArray = Array.isArray(srcSet) ? srcSet : [srcSet];
  return (
    <picture
      id={id || className}
      className={className ? `picture__${className}` : undefined}
      style={style}
    >
      {srcSetArray.slice(0, -1).map((src) => (
        <source key={src} srcSet={src} type={`image/${src.substring(src.lastIndexOf('.') + 1)}`} />
      ))}
      <img
        src={srcSetArray[srcSetArray.length - 1]}
        className={className}
        style={style}
        alt={alt}
        loading={loading}
        data-qa-id={dataQaId}
        width={width}
        height={height}
        onError={onError}
        onLoad={onLoad}
      />
    </picture>
  );
};
